/**
 * Frosted-glass surface of the CRM shell: the sidebar card and the top-bar
 * controls (search, language, theme, user menu). Tokens come from
 * `html[data-shell="crm"]` in index.css.
 */
export const GLASS_SURFACE =
    'border border-glass-nav-border bg-glass-nav backdrop-blur-xl backdrop-saturate-150';

/** 36px glass icon button for the top bar. */
export const GLASS_ICON_BUTTON = `${GLASS_SURFACE} h-9 w-9 rounded-md p-0 text-muted-foreground hover:bg-background hover:text-foreground [&_svg]:size-4`;
